import { Component } from '@angular/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { HierarchyElementModel, CorpHierarchyModel } from 'src/app/models';

@Component({
  selector: 'app-edit-hierarchy-element-modal',
  templateUrl: './edit-hierarchy-element-modal.component.html',
  styleUrls: ['./edit-hierarchy-element-modal.component.scss'],
})
export class EditHierarchyElementModalComponent {
  hierarchyElement: HierarchyElementModel;
  corpHierarchy: CorpHierarchyModel;

  constructor(public modal: BsModalRef, options: ModalOptions) {
    if (!options.initialState) {
      return;
    }
    const { hierarchyElement, corpHierarchy } = options.initialState as any;
    this.hierarchyElement = hierarchyElement;
    this.corpHierarchy = corpHierarchy;
  }
}
